import { render } from "./ChangeRemindBy.vue?vue&type=template&id=306868d8&scoped=true"
import script from "./ChangeRemindBy.vue?vue&type=script&lang=js"
export * from "./ChangeRemindBy.vue?vue&type=script&lang=js"

import "./ChangeRemindBy.vue?vue&type=style&index=0&id=306868d8&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306868d8"]])

export default __exports__